import {Component, OnInit} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {HeadComponent} from "../../components/head/head.component";
import {MatButton, MatIconButton} from "@angular/material/button";
import {
  MatCell,
  MatCellDef,
  MatColumnDef,
  MatHeaderCell, MatHeaderCellDef,
  MatHeaderRow,
  MatHeaderRowDef,
  MatRow, MatRowDef, MatTable
} from "@angular/material/table";
import {MatIcon} from "@angular/material/icon";
import {NgIf} from "@angular/common";
import {PopinComponent} from "../../components/popin/popin.component";
import {UserService} from "../../services/api/user/user.service";
import {User, UserCreateRequest, UserPatchRequest} from "../../services/api/user/models";
import {TransactionService} from "../../services/api/transaction/transaction.service";
import {TransactionResponse} from "../../services/api/transaction/model";

@Component({
  selector: 'app-admin-page',
  standalone: true,
  imports: [
    FormsModule,
    HeadComponent,
    MatButton,
    MatCell,
    MatCellDef,
    MatColumnDef,
    MatHeaderCell,
    MatHeaderRow,
    MatHeaderRowDef,
    MatIcon,
    MatIconButton,
    MatRow,
    MatRowDef,
    MatTable,
    NgIf,
    PopinComponent,
    ReactiveFormsModule,
    MatHeaderCellDef
  ],
  templateUrl: './admin-page.component.html',
  styleUrl: './admin-page.component.css'
})
export class AdminPageComponent implements OnInit {
  isPopinOpen = false
  userData: User[] = []
  userColumns: string[] = ['username', 'email', 'is_active', 'is_admin', 'id_update', 'id_delete'];
  isdeletePopin = false;
  userToDelete: number | undefined;
  userForm = {
    username: "",
    email: "",
    password: "",
    confirm_password: "",
  }
  errorMessage = '';
  transactionData: TransactionResponse[] = []
  transactionColumns : string[] = ['item_name', 'type', 'actual_quantity', 'added_by', 'updated_date'];

  constructor(
    private userService: UserService,
    private transactionService: TransactionService,
  ) {
  }

  ngOnInit() {
    this.getUsers();
    this.getTransactions();
  }

  getUsers() {
    this.userService.getUsers().subscribe(res => {
      this.userData = res;
    })
  }

  deleteUser(index: number) {
    this.isdeletePopin = true;
    this.userToDelete = index
  }

  createUser() {
    if (this.userForm.password === this.userForm.confirm_password) {
      const body: UserCreateRequest = {
        email: this.userForm.email,
        username: this.userForm.username,
        password: this.userForm.password,
      }
      this.userService.createUser(body).subscribe(res => {
        this.getUsers();
        this.closePopin();
      })
    } else {
      this.errorMessage = "Mot de passe non valide "
    }
  }

  closePopin() {
    this.isPopinOpen = false;
    this.resetForm();
    this.isdeletePopin = false;
  }

  resetForm() {
    this.userForm = {
      username: "",
      email: "",
      password: "",
      confirm_password: "",
    }
  }

  confirmDelete() {
    if (this.userToDelete) {
      this.userService.deleteUser(this.userToDelete).subscribe(res => {
        this.getUsers();
        this.closePopin();
      })
    }
  }

  updateUser(user: User) {
    const body: UserPatchRequest = {
      is_admin: !user.is_admin
    }
    this.userService.patchUser(user.id, body).subscribe(res => {
      this.getUsers();
    })
  }

  getTransactions() {
    this.transactionService.getTransactions().subscribe(res => {
      this.transactionData = res;
    })
  }
}
